// extracted by mini-css-extract-plugin
export default {"container":"StickyFooter_container__XIdNo"};